import Vue from 'vue'
import Vuex from 'vuex'
import company from './company';
import country from './country';
import account from './account';
import currency from './currency';
import dimension from './dimension';
import accountType from './accountType';
import accountGroup from './accountGroup';
import reportingPeriod from './reportingPeriod';
import reportingPeriodStatus from './reportingPeriodStatus';
Vue.use(Vuex)

export default {
    namespaced: true,
    state: {
        routePrefix: '/ledger'
    },
    mutations: {
    },
    actions: {
    },
    modules: {
        company,
        country,
        account,
        currency,
        dimension,
        accountType,
        accountGroup,
        reportingPeriod,
        reportingPeriodStatus
    }
}
